import { render, staticRenderFns } from "./examinerManage_addAndEdit.vue?vue&type=template&id=5d5f12fe&scoped=true"
import script from "./examinerManage_addAndEdit.vue?vue&type=script&lang=js"
export * from "./examinerManage_addAndEdit.vue?vue&type=script&lang=js"
import style0 from "./examinerManage_addAndEdit.vue?vue&type=style&index=0&id=5d5f12fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f12fe",
  null
  
)

export default component.exports